<template>
  <section class="nf-page">
    <div class="nf-hero">
      <h1>Flyer Info</h1>
      <p>Publishing details, creator attribution, and location information.</p>
    </div>
    <div class="nf-panel nf-stack">
      <p><strong>Title:</strong> {{ flyer.title }}</p>
      <p><strong>Creator:</strong> {{ flyer.author }}</p>
      <p><strong>Location:</strong> {{ flyer.location }}</p>
      <p><strong>Status:</strong> {{ flyer.status }}</p>
      <router-link class="nf-link" :to="`/flyers/${flyer.id}`">View detail</router-link>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { sampleFlyers } from '@/data/flyers'

const route = useRoute()
const flyer = computed(() => sampleFlyers.find((item) => String(item.id) === route.params.id) || sampleFlyers[0])
</script>
